'use client';

import { getCountries } from '@/app/utils/fetchdata';
import { useFormStatus } from 'react-dom';
import { useRouter } from '@/i18n/routing';
import { useEffect, useState, useActionState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { useTranslations } from 'next-intl';

function SubmitButton({ text, submitting }) {
  const { pending } = useFormStatus();
  return (
    <button
      disabled={pending}
      className="flex w-1/2 mx-auto justify-center rounded-md bg-gradient-to-r from-orange-500 to-pink-500 px-3 p-3 text-sm font-semibold leading-6 text-white"
      title="Submit"
      type="submit"
    >
      {pending ? (
        <div className="flex" disabled={pending}>
          <FaSpinner className="animate-spin me-2" size={'25'} />{' '}
          <span>{submitting}...</span>
        </div>
      ) : (
        text
      )}
    </button>
  );
}

export default function Form({ formAction, formType }) {
  const [formState, action] = useActionState(formAction, { success: false });
  const router = useRouter();

  const [countryList, setCountryList] = useState([]);
  const t = useTranslations('contact_us.form');

  //Fetching Countries
  useEffect(() => {
    async function fetchData() {
      const data = await getCountries();
      console.log(data);
      setCountryList(data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (formState.success) {
      router.push('/thank-you');
    }
  }, [formState]); //eslint-disable-line

  return (
    <div className="mt-4 w-full mx-auto">
      <form className="space-y-3 mx-3" action={action}>
        <input value={formType} type="hidden" name="formType" />
        <div className="relative">
          <div className="mt-2">
            <input
              id="name"
              name="name"
              type="text"
              required
              placeholder=" "
              className="peer block w-full rounded-md border-0 p-4 text-gray-900 shadow-sm ring-1 ring-inset focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ring-gray-300 placeholder:text-gray-400"
            />
            <label
              htmlFor="name"
              className="absolute left-2 top-3.5 text-sm text-gray-700 transition-all peer-focus:-top-0.5 peer-focus:text-blue-500 peer-focus:text-sm not:peer-placeholder-shown:top-0.5 peer-placeholder-shown:text-base"
            >
              {t('name')} <span className="text-red-400">*</span>
            </label>
          </div>
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.name}</p>
          )}
        </div>

        <div>
          <div className="mt-2 relative">
            <input
              id="email"
              name="email"
              type="email"
              required
              placeholder=" "
              className="peer block w-full rounded-md border-0 p-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
            <label
              htmlFor="email"
              className="absolute left-2 top-3.5 text-sm text-gray-700 transition-all peer-focus:-top-0.5 peer-focus:text-blue-500 peer-focus:text-sm not:peer-placeholder-shown:top-0.5 peer-placeholder-shown:text-base"
            >
              {t('email')} <span className="text-red-400">*</span>
            </label>
          </div>
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.email}</p>
          )}
        </div>
        <div>
          <div className="mt-2 flex gap-2">
            <select
              id="country"
              name="country"
              type="text"
              className="form-select flex-none w-1/3 rounded-md appearance-none p-2 block border border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 "
              required
            >
              <option value={''}>{t('country')}</option>
              {countryList.map((item) => {
                return (
                  <option key={item.name} value={item.name}>
                    {item.name}(+ {item.dailcode})
                  </option>
                );
              })}
            </select>
            {formState.errors && (
              <p className=" text-red-600 text-start">
                {formState.errors.country}
              </p>
            )}
            <div className="relative w-full">
              <input
                id="phone"
                name="phone"
                type="text"
                required
                placeholder=" "
                className="peer block flex-1 w-full focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md border-0 p-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
              />
              <label
                htmlFor="phone"
                className="absolute left-2 top-3.5 text-sm text-gray-700 transition-all peer-focus:-top-0.5 peer-focus:text-blue-500 peer-focus:text-sm not:peer-placeholder-shown:top-0.5 peer-placeholder-shown:text-base"
              >
                {t('phone')} <span className="text-red-400">*</span>
              </label>
            </div>
          </div>
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.phone}</p>
          )}
        </div>
        <div>
          <div className="mt-2 relative">
            <textarea
              rows={3}
              id="interest"
              name="interest"
              type="text"
              placeholder=""
              required
              className="peer block w-full focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md border-0 p-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
            />
            <label
              htmlFor="interest"
              className="absolute left-2 top-3.5 text-sm text-gray-700 transition-all peer-focus:-top-0.5 peer-focus:text-blue-500 peer-focus:text-sm not:peer-placeholder-shown:top-0.5 peer-placeholder-shown:text-base"
            >
              {t('comment')} <span className="text-red-400">*</span>
            </label>
          </div>
          {formState.errors && (
            <p className=" text-red-600 text-start">
              {formState.errors.interest}
            </p>
          )}
        </div>
        {formState.errors && (
          <p className=" text-red-600 text-start">{formState.message}</p>
        )}
        <div>
          <SubmitButton
            text={t('sub_btn.text')}
            submitting={t('sub_btn.submitting')}
          />
        </div>
      </form>
    </div>
  );
}
